import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';
import { useKpiUnit } from 'src/hooks/useKpiUnit';
import { useMergeBenchmarkTimeseries } from 'src/hooks/useMergeBenchmarkTimeseries';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';
import { useDADataContext } from '../../../contexts/DADataContext';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { Activity } from 'lucide-react';

export const TotalConversions: React.FC = () => {
  const { sales, benchmarkSales } = useDADataContext();
  const { getMergedTimeSeries } = useMergeBenchmarkTimeseries();

  const { isEuro } = useKpiUnit();
  const { metricLabel } = useKpiMetricLabels();

  const keyMetricData: KeyMetricData = useMemo(() => {
    const data = getMergedTimeSeries(
      sales.day,
      benchmarkSales.day,
      (v) => v,
      (v) => ({ benchmark: v.value }),
      false,
      'day',
    );

    return {
      name: `Total ${metricLabel}`,
      data,
      isEuro,
      summaryValue: sales.total,
      isError: sales.isError,
      isLoading: sales.isLoading,
    };
  }, [sales, isEuro, benchmarkSales, getMergedTimeSeries, metricLabel]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      title={`Total ${metricLabel}`}
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={keyMetricData.isLoading}
      isError={keyMetricData.isError}
      icon={<ChakraIcon as={Activity} boxSize={5} color="gray.500" />}
    />
  );
};
